































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import dayjs from 'dayjs';

import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TypeBox from '@/components/TypeBox/TypeBox.vue';
import { TextField } from '@/components/atoms';
import {
  CustomersList,
  TransactionsList,
  NewCustomersList
} from '@/components/organisms/BusinessDetail';
import { IPeriod } from '@/models/period';
import DateUtils from '@/utils/DateUtils';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import { SuperAdminPermission } from '@/models/super-admin';

@Component({
  components: {
    TextField,
    SideModalHeader,
    TypeBox,
    CustomersList,
    TransactionsList,
    NewCustomersList,
    FilledButton
  }
})
export default class CustomerDetail extends Vue {
  @Prop({ required: true }) data: any;
  tab: string = 'customers';
  period: IPeriod = this.initialPeriod;

  get getPicture() {
    try {
      if (!this.data.picture.includes('https')) return '';
      return {
        background: `url('${this.data.picture}')`,
        backgroundSize: 'cover'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  get initialPeriod() {
    return {
      end: new Date().toISOString(),
      start: dayjs()
        .utc()
        .add(-4, 'years')
        .toISOString(),
      shortcut: ''
    };
  }

  get hasKeywordPermission() {
    const permissions = this.$store.getters['manager/getPermissions'];

    return [SuperAdminPermission.KeywordUpdate].some(permission =>
      permissions.includes(permission)
    );
  }

  get getLabelByPeriod() {
    const { start, end } = this.period;
    const format = (date: string) => DateUtils.formattedDate({ date });

    return `${format(start)} - ${format(end)}`;
  }

  closeKeywords() {
    const modalConfig = {
      isOpen: true,
      component: 'adminBusinessDetails',
      data: this.data,
      width: '750px'
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  openKeywords() {
    const modalConfig = {
      isOpen: true,
      component: 'adminBusinessDetails',
      data: { ...this.data, close: this.closeKeywords },
      width: '750px',
      subModal: {
        isOpen: true,
        component: 'adminBusinessKeywords'
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  onPeriodInput(newValue: IPeriod) {
    if (newValue && newValue.start && newValue.end) {
      const value = newValue;
      value.start = `${newValue.start}Z`;
      value.end = `${newValue.end}Z`;
      value.shortcut = newValue.shortcut;

      this.period = value;
    }
  }

  selectTab(tab: string) {
    this.tab = tab;
  }
}
